export const readAFile = filePath => {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();

        try {
            reader.addEventListener(
                "load",
                evt => {
                    resolve(evt.target.result);
                },
                false
            );
            reader.readAsText(filePath);
        } catch (err) {
            reject(err);
        }
    });
};

export const saveFileToDownloadDirectory = (filename, content) => {
    const atag = document.createElement("a");
    const file = new Blob([content], { type: "text/plain" });
    atag.href = URL.createObjectURL(file);
    atag.download = filename;
    document.body.appendChild(atag); // Required for this to work in FireFox
    atag.style.display = "none";
    atag.click();
    document.body.removeChild(atag);
    URL.revokeObjectURL(atag.href);
}